import React from "react";
import sidebarMap from "../../config/menuMapping";
import { useDesign } from "../../context/contextDesign";
import { useThemeMode } from "../../context/contextTheme";
import { useNavigate } from "react-router-dom";
import "../styles/cloud.css";

const CloudDashboardLegacy = () => {
  const { theme } = useThemeMode();
  const navigate = useNavigate();
  const { zoom, bHeightVal } = useDesign();

  // Extract the Cloud section (id: 3)
  const cloudSection = sidebarMap[3];
  const cloudItems = cloudSection?.subMenu
    ? Object.values(cloudSection.subMenu)
    : [];

  return (
    <div className="cloud-dashboard" style={{ zoom: zoom }}>
      <div
        className="container-fluid d-flex justify-content-center align-items-center"
        style={{ height: bHeightVal }}
      >
        <div className="row justify-content-center">
          {cloudItems.map((cloud) => (
            <div className="col-auto text-center px-4" key={cloud.id}>
              <div
                className="card fw-semibold fs-6 gap-2 p-1 px-3 shadow-sm rounded-4 position-relative"
                onClick={() => navigate(cloud.path)}
                style={{
                  height: 300,
                  width: 200,
                  transition: "all 0.3s",
                  background: theme.background,
                  cursor: "pointer",
                }}
              >
                {/* Cloud Logo */}
                <div className="d-flex flex-column justify-content-between align-items-center">
                  <div style={{ width: "auto" }}>
                    {cloud.src && (
                      <img
                        className="py-5 w-100"
                        src={cloud.src}
                        alt={cloud.alt || cloud.title}
                      />
                    )}
                  </div>

                  {/* Button Text */}
                  <div
                    className="mb-2 rounded-3 w-100 btn border-0 text-white fs-6 fw-bold"
                    style={{ height: 40, background: theme.textColor }}
                  >
                    {cloud.title}
                  </div>
                </div>

                {/* Optional Red Status Badge */}
                <div>
                  <span
                    className="position-absolute top-0 start-100 badge rounded-circle bg-danger p-1"
                    style={{ marginLeft: -18, marginTop: 10 }}
                  >
                    <span className="visually-hidden">unread messages</span>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Show message if no cloud data available */}
        {cloudItems.length === 0 && (
          <div className="text-center text-muted fs-5">
            No cloud dashboards available.
          </div>
        )}
      </div>
    </div>
  );
};

export default CloudDashboardLegacy;
